import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FaRocket } from 'react-icons/fa';
import CoreButton from '../../common/Button';
import '../../../styles/common/core/ExecuteBox.css';
import InputDefaultTextContainer from "../../common/core/InputDefaultTextContainer";

const ExecuteBox = ({ onClick, disabled, showInput }) => {
    const [tenants, setTenants] = useState("");
    const [inputClassname, setInputClassname] = useState("");
    const [isBtnDisabled, setBtnDisabled] = useState(disabled);
    const [isSendDelay, setSendDelay] = useState(false);    
    const delay = 2500; //  see CoreButton delay

    const handleChange = (tenants) => {
        setTenants(tenants);
    };

    const handleClick = (componentName) => {
        if (disabled || isSendDelay) {
            return;
        }
        sendDelay(componentName);        
        if (showInput && tenants === "") {
            setInputClass("wrong-input");
            return;
        }
        setInputClass("correct-input");
        onClick(tenants);
    };

    const handleKeyEscape = () => {
        setTenants("");
    };

    const setInputClass = (className) => {
        setInputClassname(className);
        setTimeout(() => setInputClassname(""), delay);  //  animate
    };

    const sendDelay = (componentName) => {
        if (componentName === "input") {
            setBtnDisabled(true);
            setTimeout(() => setBtnDisabled(false), delay);
        }
        setSendDelay(true);
        setTimeout(() => setSendDelay(false), delay);
    };

    return (
        <div className="execute-box" >
            <span>Manual run{showInput ? ":" : ""}</span>
            {showInput &&
                <InputDefaultTextContainer
                    className={inputClassname}
                    defaultText="for tenants..."
                    value={tenants}
                    isValidate={false}
                    isDisabled={disabled}
                    onChange={handleChange}
                    onKeyEnter={() => handleClick("input")}
                    onKeyEscape={handleKeyEscape}
                />
            }
            <CoreButton
                disabled={isBtnDisabled}
                onClick={() => handleClick("button")}
                icon={<FaRocket />}
            />
        </div>
    );
}

ExecuteBox.propTypes = {
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    showInput: PropTypes.bool
}

ExecuteBox.defaultProps = {
    onClick: null,
    disabled: false,
    showInput: true
}

export default ExecuteBox;